// extracted by mini-css-extract-plugin
module.exports = {"selectedTag":"selected-tag_selectedTag__L1rjP","title":"selected-tag_title__qhyIA","clear":"selected-tag_clear__2-QpK"};